import { render } from "./ProductSelectionProductsFilters.vue?vue&type=template&id=d6ecdd1a&scoped=true&ts=true"
import script from "./ProductSelectionProductsFilters.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionProductsFilters.vue?vue&type=script&lang=ts"

import "./ProductSelectionProductsFilters.vue?vue&type=style&index=0&id=d6ecdd1a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6ecdd1a"]])

export default __exports__